import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-279bbad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-config-drawer-list-course-item-info" }
const _hoisted_2 = { class: "app-config-drawer-list-course-item-info-name" }
const _hoisted_3 = { style: {"margin-top":"10px","display":"flex","align-items":"center"} }
const _hoisted_4 = {
  style: {"display":"flex","align-items":"center","font-size":"var(--font-size-assistant)","font-weight":"var(--font-weight-light)"},
  class: "secondary-text"
}
const _hoisted_5 = { style: {"margin-left":"2px"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_7 = {
  class: "font-size-assistant secondary-text",
  style: {"display":"flex","height":"30px","align-items":"center"}
}

import {computed, onMounted, PropType, ref, watchEffect} from "vue";
import {VideoCamera} from "@element-plus/icons-vue";
import {AppConfigComponentListStyle} from "@/model/AppConfig";
import {Resource} from "@/model/Resource";


const __default__ = {
  name: "AppConfigComponentDrawerResourceHorizontalCom"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  resource: {
    type: Object as PropType<Resource>,
    required: true
  },
  listStyle: {
    type: Number as PropType<AppConfigComponentListStyle>,
    required: true
  }
},
  setup(__props) {

const props = __props



const domRef = ref<any>(null)
const width = ref<number>(0)

watchEffect(() => {
  if (domRef.value && domRef.value.clientWidth > 0) {
    width.value = domRef.value.clientWidth
  }
})

onMounted(() => {
  setTimeout(() => {
    if (width.value == 0) {
      if (domRef.value && domRef.value && domRef.value.clientWidth > 0) {
        width.value = domRef.value.clientWidth
      }
    }
  }, 300)
})

const imageHeight = computed(() => {
  return (width.value / 1.77).toFixed(2) + "px"
})


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (__props.resource)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "domRef",
        ref: domRef,
        class: "app-config-drawer-list-course-item"
      }, [
        _createVNode(_component_el_image, {
          fit: "cover",
          class: "app-config-drawer-list-course-item-image",
          style: _normalizeStyle({height: _unref(imageHeight)}),
          src: __props.resource.pcImageUrl
        }, null, 8, ["style", "src"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.resource.name), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_icon, { style: {"padding-bottom":"2px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(VideoCamera))
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_5, _toDisplayString(__props.resource.videoNumber || '0') + "节", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (__props.resource.teachers)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.resource.teachers, (teacher, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: _normalizeStyle({marginLeft: index > 0 ? '16px' : '0px'})
                    }, [
                      _createVNode(_component_el_avatar, {
                        size: 30,
                        fit: "fill",
                        src: teacher.avatarUrl
                      }, null, 8, ["src"])
                    ], 4))
                  }), 256))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (__props.resource.tags && __props.resource.tags.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.resource.tags, (tag, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (index < 2)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "gray-tag",
                            style: _normalizeStyle({marginLeft: index > 0 ? '5px' : '0px'})
                          }, _toDisplayString(tag.name), 5))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})